// UserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [userinfo, setUserInfo] = useState({
        "avatar":""
    });
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        // Simulate fetching user data (e.g., from localStorage, API call)
        const fetchUserData = () => {
            fetch("/api/user/current").then(response=>response.json()).then(result=>{
                let data = result.data
                if (data){
                    setUserInfo(data);
                    setIsLogin(true)
                }else {
                    setUserInfo({});
                    setIsLogin(false)
                }

            })
        };

        fetchUserData();
    }, []);

    return (
        <UserContext.Provider value={{userinfo, isLogin}}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
